<script setup>
  defineProps({
    events: {
      type: Array,
      default: () => []
    }
  })

  const getPrimaryDate = (dates) => {
    if (!Array.isArray(dates) || !dates.length) {
      return null
    }

    return dates[0]
  }

  const dateString = (date) => {
    if (!date) {
      return ''
    }

    if (date.startDate === date.endDate) {
      return date.startDate
    }

    return `${date.startDate} - ${date.endDate}`
  }

  const eventSummary = (event) => {
    const summaryParts = []
    const eventDate = getPrimaryDate(event.dates)
    const followUpDate = getPrimaryDate(event.followUp?.dates)

    if (eventDate) {
      summaryParts.push(dateString(eventDate))
    }

    if (event.location) {
      summaryParts.push(event.location)
    }

    if (followUpDate) {
      summaryParts.push(`Follow up am ${dateString(followUpDate)}`)
    }

    return summaryParts.join(' / ')
  }
</script>

<template>
  <div class="curriculum-events mt-6 flex flex-col gap-6">
    <article
      v-for="event in events"
      :key="event.id"
      class="curriculum-event grid grid-cols-12 py-2"
    >
      <p
        class="col-span-8 ~pr-4/8 text-base max-w-lg"
      >
        {{ eventSummary(event) }}
      </p>
      <a
        :href="event.url"
        target="_blank"
        class="curriculum-event-link underline underline-offset-2 col-span-2"
        :aria-label="`Zur Terminanmeldung für ${event.title}`"
      >
        Details
      </a>
      <div
        class="curriculum-event-booking-indicator col-span-2 flex flex-row items-start justify-end gap-3"
      >
        <p>
          Buchen
        </p>
        <span
          class="h-4 w-4 rounded-full border-2 border-gold mt-1.5"
        />
      </div>
    </article>
  </div>
</template>

<style lang="scss" scoped>
  :deep(svg) {
    @apply w-5 h-5;
  }

  .curriculum-event-link :deep(svg) {
    @apply mr-2 w-4 h-4;
  }

  .curriculum-event-link :deep(svg path) {
    fill: #fff !important;
  }
</style>
